



























































import VueOptions from '@utils/VueOptions'
import WizardNavbar from '@ui/AudienceCreativeWizard/WizardNavbar'
import WizardNavigation from '@ui/AudienceCreativeWizard/WizardNavigation'
import SetupForm from '@ui/SpaceWizards/OnsiteSpaceWizard/Forms/SetupForm'
import OnsiteSpaceAvailabilityBindSelector from '@ui/ResourceBindSelector/OnsiteSpaceAvailabilityBindSelector'
import Modal from '@components/Modal'

settings =
  name: 'OnsiteSpaceEditStep'

  resources:
    space_booth:
      resourceName: 'space_booth'
      slug: 'suppliers/:wizard.supplierId/audience_creatives/:audienceCreativeId/space_booths/:spaceId/edit'
    availabilities:
      resourceName: 'audience_availability'
      slug: 'suppliers/:wizard.supplierId/audience_availabilities'
      fetch: false
      params:
        quick_list: true

  vue:
    props: ['wizard', 'step']

    components: {
      WizardNavbar,
      WizardNavigation,
      SetupForm,
      OnsiteSpaceAvailabilityBindSelector,
      Modal,
    }

    data: ->
      confirmModal:
        show: false
      missingCapacityModal:
        show: false

    computed:
      spaceId: ->
        @$route.query.spaceId

      form: ->
        data: @prime?.space_booth
        errors: @formErrors.space_booth || {}

      segment: -> @form.data?.segment

      actionsForSetupForm: ->
        saveField: @saveField
        fetchSpace: @fetchSpaceBooth

      optionsForBindSelector: ->
        supplierId: @wizard.supplierId
        disabled: !@hasSpaces

      spaceAvailabilityIds: ->
        @form.data?.availability_ids || []

      spaceAvailabilities: ->
        av for av in (@availabilities || []) when av.id in @spaceAvailabilityIds

      missingCapacityCount: ->
        return 0 unless @form.data?
        return 0 if @form.data.segment_renamed
        count = 0
        { segment } = @form.data || {}
        for availability in @spaceAvailabilities
          count++ if @isEmptyValue availability.engagement_capacity[segment]?.reach
        count

      hasSpaces: ->
        @form.data?.spaces?.length > 0

      hasVenues: ->
        @spaceAvailabilityIds.length > 0

    methods:
      hiNavigate: ->
        @wizard.navToStepName @step.navigation.next.to

      saveField: (fieldName) ->
        @saveItem 'prime.space_booth', null, { skipFlash: true }

      onSave: (item) ->
        @fetchSpaceBooth()

      fetchSpaceBooth: -> 
        @fetch 'space_booth'

    watch:
      'wizard.audienceCreativeData': ->
        @fetch 'space_booth'
      requestIsPending: (value) ->
        @wizard.hideWaitingModal() unless value

      segment: (newSegment) ->
        @$router.replace { query: { ...@$route.query, spaceId: newSegment } }

export default VueOptions.vue settings
